export default "__VITE_ASSET__Uv420o2R__"